export default __webpack_public_path__ + "static/media/blank.9d75e8e7.jpg";